import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Checkbox } from 'semantic-ui-react';

const PolicyVerification = ({ data, onChange, loading, onShowTerms }) => {
	const _onChange = useCallback(
		(e, data) => {
			var { name, value } = data;

			if ((name === 'policyHolder' || name === 'zip') && value !== '') {
				onChange(e, { name: 'paymentNumber', value: '' });
			} else if (name === 'paymentNumber' && value !== '') {
				onChange(e, { name: 'policyHolder', value: '' });
				onChange(e, { name: 'zip', value: '' });
			}

			onChange(e, data);
		},
		[onChange]
	);

	const allEmpty = useMemo(() => !data.paymentNumber && !data.policyHolder && !data.zip, [data]);

	return (
		<Form loading={loading}>
			<Form.Input name='policyNumber' placeholder='Policy Number' onChange={onChange} value={data.policyNumber || ''} label='Policy Number' required={(!data.paymentNumber && !data.accountNumber) || data.paymentNumber} disabled={!!data.accountNumber} />
			<Form.Input name="accountNumber" placeholder='Account Number' onChange={onChange} value={data.accountNumber || ''} label='Account Number' required={!data.policyNumber && !data.paymentNumber} disabled={!!data.paymentNumber || !!data.policyNumber} />
			<Form.Input name='paymentNumber' placeholder='Online Payment Number' onChange={_onChange} value={data.paymentNumber || ''} label='Online Payment Number' disabled={!!data.policyHolder || !!data.zip || !!data.accountNumber} required={(!data.policyNumber && !data.accountNumber) || !!data.paymentNumber} type="number" />
			<Form.Input name='policyHolder' placeholder='Policyholder or Business Name' onChange={_onChange} value={data.policyHolder || ''} label='Policyholder or Business Name' disabled={!!data.paymentNumber} required={!!data.policyHolder || !!data.zip || allEmpty} />
			<Form.Input name='zip' placeholder='Billing Zip Code' onChange={_onChange} value={data.zip || ''} label='Billing Zip Code (5 digits)' disabled={!!data.paymentNumber} required={!!data.policyHolder || !!data.zip || allEmpty} type="number"/>
			<Form.Field className='centered'>
				<Button content='Show Terms' type='button' onClick={onShowTerms} />
			</Form.Field>
			<Form.Field className='centered'>
				<Checkbox name='agreeTerms' label='I have read and accept the above terms' onChange={onChange} checked={data.agreeTerms} />
			</Form.Field>
		</Form>
	);
};

PolicyVerification.propTypes = {
	data: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired,
	onShowTerms: PropTypes.func.isRequired,
	loading: PropTypes.bool.isRequired
};

export default PolicyVerification;
